<template>
  <div class="patrol-number">
    <Title :img="triangleImg" name="今日巡检次数" :callback="onClick" />
    <div class="patrol-number-content">
      <div style="display: flex;align-items: center;">
        <img src="@/assets/image/Drone.png" alt="无人机巡检" style="width: 1.5rem;height: 1.5rem;"></img>
        <div style="display: flex;flex-direction: column;margin-left: 0.5rem;"><span
            style="font-size: 1rem;font-weight: bold;">5次</span><span
            style="font-size: 0.6rem;color: #FFF;">无人机巡检</span></div>
      </div>
      <div style="display: flex;align-items: center;">
        <img src="@/assets/image/PatrolVehicle.png" alt="巡检车巡检" style="width: 1.5rem;height: 1.5rem;"></img>
        <div style="display: flex;flex-direction: column;margin-left: 0.5rem;"><span
            style="font-size: 1rem;font-weight: bold;">2次</span><span
            style="font-size: 0.6rem;color: #FFF;">巡检车巡检</span></div>
      </div>
      <div style="display: flex;align-items: center;">
        <img src="@/assets/image/artificial.png" alt="人工巡检" style="width: 1.5rem"></img>
        <div style="display: flex;flex-direction: column;margin-left: 0.5rem;"><span
            style="font-size: 1rem;font-weight: bold;">0次</span><span
            style="font-size: 0.6rem;color: #FFF;">人工巡检</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title/title.vue'
import triangleImg from '@/assets/image/triangle.png'
import Patrol from "../../patrol/Patrol";

export default {
  name: 'VendorRanking',
  components: { Patrol, Title },
  data() {
    return {
      triangleImg: triangleImg,
    }
  },
  mounted() {

  },

  methods: {
    onClick() {
      this.$router.push({ path: "/patrol-center" });
    }
  }
}
</script>

<style lang="less" scoped>
.patrol-number {
  position: relative;
  height: 15%;
  width: 100%;
  border-radius: 5px;
  padding: 0.5rem;
  background:
    /* 左上角圆形渐变 */
    radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
    /* 右上角圆形渐变 */
    radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
    /* 中间半透明背景 */
    linear-gradient(to bottom, #171e2127, #171e2127);

  .patrol-number-content {
    display: flex;
    height: calc(100% - 2rem);
    width: 100%;
    color: white;
    padding: 0.5rem 0;
    justify-content: space-between;

    .chart-container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>